import { useCallback } from "react";

import { mnpTrademarkNavigation } from "../../../app/navigation";
import { useMonitorAndProtectTrademarkDataAndParams } from "../../../shared/hooks/trademark-params";

export const useDomainFilterQuickApply = () => {
    const { dataFilters } = useMonitorAndProtectTrademarkDataAndParams();
    const { domains } = dataFilters;

    const toggleField = useCallback(
        (field: "include" | "exclude", domain: string) => {
            const parse = () => {
                if (!domains) {
                    return {
                        [field]: [domain],
                    };
                }

                const fieldValues = domains[field] || [];
                if (fieldValues.includes(domain)) {
                    const res = fieldValues.filter((d) => d !== domain);
                    return {
                        ...domains,
                        [field]: res.length > 0 ? res : undefined,
                    };
                }

                return {
                    ...domains,
                    [field]: [...fieldValues, domain],
                };
            };

            const result = parse();
            const cleanResponse = Object.values(result).filter(Boolean).length > 0 ? result : undefined;
            return cleanResponse;
        },
        [domains],
    );

    const toggleInclude = useCallback(
        (domain: string) => {
            mnpTrademarkNavigation.updateQueryParams({
                dataFilters: {
                    ...dataFilters,
                    domains: toggleField("include", domain),
                },
            });
        },
        [dataFilters, toggleField],
    );

    const toggleExclude = useCallback(
        (domain: string) => {
            mnpTrademarkNavigation.updateQueryParams({
                dataFilters: {
                    ...dataFilters,
                    domains: toggleField("exclude", domain),
                },
            });
        },
        [dataFilters, toggleField],
    );

    return {
        toggleInclude,
        toggleExclude,
    };
};
